import { ref } from "vue";
import { d as defaultsKey } from "../../../keys-CLEaYsGj.mjs";
const defaultsPlugin = {
  install(app, options) {
    const val = (options == null ? void 0 : options.components) ?? {};
    app.provide(defaultsKey, ref(val));
  }
};
export {
  defaultsPlugin
};
//# sourceMappingURL=index.mjs.map
